import React, { useState, useEffect, useCallback } from 'react';
import { getScores } from '../services/api';
import { Trophy, Star } from 'lucide-react';

const TVLeaderboard = () => {
  const [scores, setScores] = useState([]);

  const loadScores = useCallback(async () => {
    try {
      const data = await getScores(10);
      setScores(data);
    } catch (error) {
      console.error('Error loading scores:', error);
    }
  }, []);

  useEffect(() => {
    loadScores();
    // Refresh every 30 seconds
    const interval = setInterval(loadScores, 30000);
    return () => clearInterval(interval);
  }, [loadScores]);

  return (
    <div className="tv-leaderboard" data-testid="tv-leaderboard">
      {/* Logo */}
      <div className="w-64 h-20 bg-[#005EB8] rounded-lg flex items-center justify-center border-2 border-[#FFD100] mb-8">
        <span className="font-arcade text-white text-sm">PALLETWAYS</span>
      </div>

      {/* Title */}
      <h1 className="tv-title flex items-center gap-4">
        <Trophy className="w-10 h-10" />
        PALLET MAN — HALL OF FAME
        <Trophy className="w-10 h-10" />
      </h1>

      {/* Leaderboard */}
      <div className="w-full max-w-4xl">
        {scores.length === 0 ? (
          <div className="text-center py-20">
            <Star className="w-20 h-20 text-[#FFD100] mx-auto mb-4 animate-pulse" />
            <p className="font-arcade text-xl text-[#94a3b8]">
              NESSUN PUNTEGGIO ANCORA
            </p>
            <p className="font-arcade text-sm text-[#64748b] mt-2">
              GIOCA PER ENTRARE IN CLASSIFICA!
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {scores.map((score, index) => (
              <div 
                key={score.id}
                className="tv-entry"
                style={{
                  animationDelay: `${index * 0.1}s`,
                  borderLeftColor: index === 0 ? '#FFD100' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : '#475569'
                }}
              >
                <span 
                  className="min-w-[60px]"
                  style={{
                    color: index === 0 ? '#FFD100' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : '#94a3b8'
                  }}
                >
                  #{index + 1}
                </span>
                <span className="flex-1 text-white">{score.initials}</span>
                <span className="text-[#3B82F6]">{score.score.toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Animated Footer */}
      <div className="mt-auto pt-8 w-full overflow-hidden">
        <div className="animate-marquee whitespace-nowrap font-arcade text-sm text-[#64748b]">
          ★ GIOCA A PALLET MAN ★ RACCOGLI TUTTE LE PILLOLE ★ EVITA I NEMICI ★ DIVENTA IL CAMPIONE DELLA LOGISTICA ★ GIOCA A PALLET MAN ★
        </div>
      </div>
    </div>
  );
};

export default TVLeaderboard;
